import { Link, NavLink } from "react-router-dom";
import { Menu, X, Search } from "lucide-react";
import { useState } from "react";
import ThemeToggle from "./ThemeToggle";

const links = [
  { to: "/vacancies", label: "Live Vacancies" },
  { to: "/depot-finder", label: "Vacancy Map" },
  { to: "/operators", label: "Companies Hiring Now" },
  { to: "/careers", label: "Role Guides" },
  { to: "/application-resources", label: "For Candidates" },
  { to: "/employers", label: "For Employers" },
  { to: "/faqs", label: "FAQs" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-[1100] bg-nav/85 backdrop-blur-xl border-b border-line">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-18 py-4">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/logo.png" alt="Railway Careers UK" className="w-10 h-10 rounded-full" />
          <div className="leading-tight hidden sm:block">
            <div className="font-display font-bold text-ice text-[17px] tracking-[-0.018em]">Railway Careers</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-slate font-medium">United Kingdom</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={({ isActive }) =>
                `px-3.5 py-2 text-[13px] font-medium rounded-full transition-all ${
                  isActive ? "text-sky bg-sky/10 border border-sky/25" : "text-slate hover:text-ice"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <ThemeToggle />
          <Link to="/vacancies" className="text-slate hover:text-sky transition-colors" aria-label="Search" data-testid="nav-search">
            <Search className="w-4 h-4" />
          </Link>
          <Link to="/employer-portal/login" data-testid="nav-employer-login" className="pill pill-ghost !py-2 !px-4 !text-[12px]">
            Employer sign in
          </Link>
        </div>

        <div className="lg:hidden flex items-center gap-3">
          <ThemeToggle />
          <button className="p-2 text-ice" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-mobile-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-line bg-nav">
          <div className="px-6 py-5 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-2.5 text-[14px] font-medium text-ice" data-testid={`nav-mobile-${l.to.slice(1)}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/employer-portal/login" onClick={() => setOpen(false)} className="py-2.5 text-[12px] uppercase tracking-[0.14em] text-slate">
              Employer sign in
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
